// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1hIR2","paramInput":"JobSimulator_paramInput__b-nYx","input":"JobSimulator_input__c4iZ_"};